export function humanFileSize(
  size: number | string | null | undefined,
): string {
  if (!size) return "0 Bytes";

  if (typeof size === "string") {
    size = parseFloat(size);
  }

  let k = 1000;
  let sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let i = Math.floor(Math.log(size) / Math.log(k));
  let output = parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];

  if (output.includes("NaN") || output.includes("undefined")) {
    return "";
  }

  return output;
}
